import { cn as e } from "../cn.js";
import { cva as t } from "class-variance-authority";
// src/design/popover/style.ts
var n = t("flex items-center gap-1"), r = t("transition-transform duration-normal data-[state=open]:rotate-90"), i = t("data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=closed]:animate-out data-[state=closed]:fade-out-0"), a = t("relative z-floating min-w-[240px] rounded-lg bg-card p-4 shadow-floating border border-border"), o = t("font-semibold text-foreground mb-1"), s = t("text-muted-foreground text-sm"), c = t("absolute z-0"), l = t("bg-card border-t border-l border-border"), u = () => ({
	root: (t) => e("relative", t),
	trigger: (t) => e(n(), t),
	indicator: (t) => e(r(), t),
	positioner: (t) => e(i(), t),
	content: (t) => e(a(), t),
	title: (t) => e(o(), t),
	description: (t) => e(s(), t),
	arrow: (t) => e(c(), t),
	arrowTip: (t) => e(l(), t)
});
export { u as getStyles, c as popoverArrowStyles, l as popoverArrowTipStyles, a as popoverContentStyles, s as popoverDescriptionStyles, r as popoverIndicatorStyles, i as popoverPositionerStyles, o as popoverTitleStyles, n as popoverTriggerStyles };

//# sourceMappingURL=style.js.map